import { Platform } from 'react-native';

export const DOMAIN = 'Sleepio.Throbber';
export const USE_NATIVE_DRIVER = Platform.OS !== 'web';
